/* eslint-disable no-invalid-this */
// eslint-disable-next-line func-style
export function isModalRoute(path) {
  return (this.call('findModal', path) || {}).FoundModal
}
